import React from 'react'
import classnames from 'classnames'

import styles from '@components/icons/plusminus.module.scss'

const Plusminus = ({ className, minus, color, ...rest }) => {
  const rootClasses = [styles.plusMinusIcon, className]
  if (minus) {
    rootClasses.push(styles['plusMinusIcon--minus'])
  }

  return (
    <svg
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
      className={classnames(rootClasses)}
      {...rest}
    >
      <g transform="translate(1 1)" strokeWidth="2" stroke="#00B9B4" fill="none" fillRule="evenodd">
        <circle className="c1" cx="12.5" cy="12.5" r="12.5" />
        <g transform="translate(6 7)" strokeLinecap="round">
          <path className="p1" d="M6.5.23V11.8" />
          <path className={styles.p2} d="M12.27 6H.7" />
        </g>
      </g>
    </svg>
  )
}

export default Plusminus
